import {MENU} from './api'
import {METHOD, request} from '@/utils/request'

/**
 * 查询菜单树
 * @param {*} params 
 * @returns 
 */
export  function getMenuTree(params) {
  return request(MENU+"/getMenuTree", METHOD.GET, params)
}

/**
 * 查询角色菜单树及选中状态
 * @param {*} params 
 * @returns 
 */
export  function getRoleMenuTree(params) {
  return request(MENU+"/getRoleMenuTree", METHOD.GET, params)
}

/**
 * 查询当前用户菜单
 * @returns 
 */
export function getCurrentMenu() {
  return request(MENU+"/getCurrentMenu", METHOD.GET)
}